<template>
    <alert-modal
        :title="title"
        :primaryCTAText="$t('ACTION_CLOSE')"
        :error="true"
        @close="close"
        @confirm="close"
    >
        <div class="cz2__modal-popup__copy">
            <div v-if="inventoryIssue" class="cz2__mb-25" v-html="$t('PRINT_ERROR_BODY_INVENTORY')" />
            <div v-else class="cz2__mb-25" v-html="$t('PRINT_ERROR_BODY')" />
        </div>
    </alert-modal>
</template>

<style lang="scss"></style>

<script>
    import AlertModal from './ui/AlertModal.vue';

    export default {
        components: {
            AlertModal,
        },
        data() {
            return {
                lastKnownError: null,
            };
        },
        computed: {
            title() {
                if (this.inventoryIssue) {
                    return this.$t('PRINT_ERROR_TITLE_INVENTORY');
                }

                if (this.outOfPaper) {
                    return this.$t('PRINT_ERROR_TITLE_PAPER');
                }

                return this.$t('PRINT_ERROR_TITLE');
            },

            outOfPaper() {
                if (this.lastKnownError == null) {
                    return false;
                }

                if (this.lastKnownError.paper === false) {
                    return true;
                }

                return false;
            },

            inventoryIssue() {
                const error = this.lastKnownError;

                if (error && error.includes && error.includes('inventory')) {
                    return true;
                }

                return false;
            },
        },

        mounted() {
            let error = this.$store.state.lastKnownError;

            if (error && error.response && error.response.data && error.response.data.modelState) {
                const errors = [];

                Object.keys(error.response.data.modelState).forEach((k) => {
                    errors.push(error.response.data.modelState[k]);
                });

                error = errors.join(',');
            }

            this.lastKnownError = error;
        },

        methods: {
            close() {
                this.$store.dispatch('showPrintingError', false);
            },
        },
    };
</script>
